// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderItem_btn__UhZ8f {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  background-color: var(--accent-color);
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  color: var(--accent-text-color);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 1;
  position: relative;
}
@media (hover: hover) {
  .OrderItem_btn__UhZ8f:hover {
    opacity: 0.8;
  }
}
@media (min-width: 640px) {
  .OrderItem_btn__UhZ8f {
    font-size: 20px;
    height: 76px;
  }
}
@media (min-width: 1200px) {
  .OrderItem_btn__UhZ8f {
    font-size: 12px;
    width: auto;
    height: 36px;
    padding: 0 32px;
  }
}
.OrderItem_btn__UhZ8f:disabled {
  cursor: default;
  pointer-events: none;
  background-color: #EEEEEE;
  color: rgba(21, 27, 38, 0.4);
}
.OrderItem_btn__loader__L-pHe, .OrderItem_btn__icon__-hTBE {
  position: absolute;
  transform: translateY(-50%);
  right: 12px;
  width: 16px;
  height: 16px;
  transform-origin: center;
}
.OrderItem_btn__loader__L-pHe {
  top: 50%;
  animation: OrderItem_loader__TVGGp 2s infinite linear;
  display: none;
}
.OrderItem_btn__icon__-hTBE {
  top: calc(50% + 2px);
}
@media (min-width: 1200px) {
  .OrderItem_btn__icon__-hTBE {
    display: flex;
  }
}
.OrderItem_btn--is-loading__vD96g {
  pointer-events: none;
}
.OrderItem_btn--is-loading__vD96g .OrderItem_btn__loader__L-pHe {
  display: inline-block;
}
.OrderItem_btn--is-loading__vD96g .OrderItem_btn__loader__L-pHe + .OrderItem_btn__icon__-hTBE {
  display: none;
}
.OrderItem_btn--gray__m4OIw {
  background: #EEEEEE;
  color: var(--text-color);
}
.OrderItem_btn--warning__bJYHq {
  background: linear-gradient(87.49deg, #FA7B45 -0.07%, #F44C4C 95.73%);
}
.OrderItem_btn--white__iD2py {
  background-color: var(--white);
  color: var(--text-color);
}
@media (hover: hover) {
  .OrderItem_btn--white__iD2py:hover {
    background-color: var(--accent-color);
    color: var(--accent-text-color);
  }
}
.OrderItem_btn--light__jKSRs {
  background-color: rgba(var(--accent-color-rgb), 0.12);
  color: var(--accent-color);
}
@media (hover: hover) {
  .OrderItem_btn--light__jKSRs:hover {
    background-color: var(--accent-color);
    color: var(--accent-text-color);
  }
}
.OrderItem_btn--sm-width__fMhNT {
  width: 94px;
  min-width: 94px;
}
.OrderItem_btn--sm__aqIBY {
  height: 32px;
}
@media (min-width: 1200px) {
  .OrderItem_btn--sm__aqIBY {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.OrderItem_btn--md__ImA-f {
  height: 66px;
}
@media (min-width: 640px) {
  .OrderItem_btn--md__ImA-f {
    height: 76px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .OrderItem_btn--md__ImA-f {
    height: 44px;
    font-size: 12px;
    line-height: normal;
  }
}
.OrderItem_btn--xsm__Z31s- {
  height: 44px;
  border-radius: 12px;
  padding-left: 18px;
  padding-right: 18px;
}
@media (min-width: 1200px) {
  .OrderItem_btn--xsm__Z31s- {
    height: 24px;
    border-radius: 6px;
    line-height: normal;
  }
}

@keyframes OrderItem_loader__TVGGp {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  0% {
    transform: translateY(-50%) rotate(360deg);
  }
  100% {
    transform: translateY(-50%) rotate(0deg);
  }
}
.OrderItem_orderItem__\\+DwUn {
  width: 100%;
  border-radius: 16px;
  padding: 8px;
  background: #fff;
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  position: relative;
  margin-bottom: 12px;
  text-align: left;
  cursor: pointer;
  transition: var(--transition);
  transition-property: box-shadow;
  display: flex;
  align-items: center;
}
@media (hover: hover) {
  .OrderItem_orderItem__\\+DwUn:hover {
    box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.2);
  }
}
@media (min-width: 640px) {
  .OrderItem_orderItem__\\+DwUn {
    padding: 8px 16px;
    min-height: 92px;
  }
}
.OrderItem_orderItem__\\+DwUn:last-child {
  margin-bottom: 0;
}

.OrderItem_inner__grgou {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
}
.OrderItem_inner__grgou .OrderItem_content-container__ahDho {
  display: flex;
  align-items: center;
  padding-right: 32px;
}
@media (min-width: 1200px) {
  .OrderItem_inner__grgou {
    flex-wrap: nowrap;
  }
}
@media (max-width: 1200px) {
  .OrderItem_inner__grgou {
    flex: 1 1;
  }
}

.OrderItem_imgWrap__YdFWi {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 8px;
}
@media (min-width: 640px) {
  .OrderItem_imgWrap__YdFWi {
    width: 60px;
    height: 60px;
    margin-right: 12px;
  }
}
.OrderItem_imgWrap--empty__oPSeE {
  color: var(--accent-text-color);
  background-color: rgba(var(--accent-color-rgb), 0.3);
}
.OrderItem_imgWrap__YdFWi img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
  overflow: hidden;
}

.OrderItem_time__6Wyt4, .OrderItem_number__6dqSe {
  right: 8px;
  position: absolute;
  color: #54575C;
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
}
@media (min-width: 1200px) {
  .OrderItem_time__6Wyt4, .OrderItem_number__6dqSe {
    color: #7A808B;
    font-weight: normal;
    flex-shrink: 0;
    right: 16px;
    padding-bottom: 2px;
    margin-left: auto;
  }
}

.OrderItem_time__6Wyt4 {
  bottom: 15px;
}
@media (min-width: 1200px) {
  .OrderItem_time__6Wyt4 {
    top: auto;
    padding-bottom: 2px;
    margin-left: auto;
  }
}
.OrderItem_time__6Wyt4.OrderItem_time-for-history__Wjfeu {
  top: 32px;
}
@media (min-width: 1200px) {
  .OrderItem_time__6Wyt4.OrderItem_time-for-history__Wjfeu {
    bottom: 16px;
    top: auto;
  }
}

.OrderItem_number__6dqSe {
  top: 15px;
}

.OrderItem_message__2dAsi {
  position: absolute;
  top: -6px;
  right: -6px;
  color: var(--white);
  line-height: 100%;
  background-color: #FF3C3C;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #FAFAFA;
  font-weight: 600;
  width: 24px;
  height: 24px;
  font-size: 11px;
  padding: 0;
  z-index: 1;
}

.OrderItem_info__2jMtj {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  align-items: flex-start;
}
@media (min-width: 1200px) {
  .OrderItem_info__2jMtj {
    padding: 0 20px 0 0;
  }
}

.OrderItem_name__1v7bp {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  padding-right: 12px;
}
@media (min-width: 1200px) {
  .OrderItem_name__1v7bp {
    padding-right: 0;
  }
}
.OrderItem_name__1v7bp span {
  font-weight: 400;
}

.OrderItem_completedAndRate__8sJd8 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.OrderItem_completed__Vgtl1 {
  background: #EEEEEE;
  height: 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 10px;
  line-height: 114%;
  padding: 5px;
  color: var(--text-color);
}
.OrderItem_completed__Vgtl1 span {
  color: #7A808B;
  margin-right: 4px;
}

.OrderItem_rate__niycr {
  display: flex;
  align-items: center;
}
.OrderItem_rate__niycr svg {
  width: 13px;
  height: 12px;
}
@media (min-width: 1200px) {
  .OrderItem_rate__niycr svg {
    width: 16px;
    height: 17px;
  }
}

.OrderItem_description__019YS {
  margin-top: 1px;
  line-height: 114%;
  font-size: 12px;
  color: #54575C;
}
@media (min-width: 1200px) {
  .OrderItem_description__019YS {
    font-size: 12px;
    line-height: 14px;
    color: #7A808B;
  }
}

.OrderItem_btnBlock__4-uWO {
  display: flex;
  align-content: center;
}

.OrderItem_pdfBlock__btn__rRzEF {
  margin-top: 4px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: var(--blue-500);
  transition: var(--transition);
}
.OrderItem_pdfBlock__btn__rRzEF:first-child {
  margin-left: 0;
}
.OrderItem_pdfBlock__btn__rRzEF.OrderItem_loading__6aZvz {
  opacity: 1;
  cursor: default;
  pointer-events: none;
}
.OrderItem_pdfBlock__btn__rRzEF svg {
  width: 10px;
  margin-left: 2px;
  height: 11px;
}
.OrderItem_pdfBlock__btn__rRzEF:hover {
  opacity: 0.6;
}
.OrderItem_pdfBlock__btn__rRzEF .btn__loader {
  display: block;
  right: 0;
}
.OrderItem_pdfBlock__loaderWp__PwbqW {
  position: relative;
  width: 9px;
  height: 9px;
  margin-left: 4px;
}
.OrderItem_pdfBlock__loaderWp__PwbqW img {
  width: 9px;
  height: 9px;
}
.OrderItem_pdfBlock__download__uabGL {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--text-color);
  padding: 3px 6px;
  background: #FAFAFA;
  text-decoration: none;
  border-radius: 2px;
  height: 20px;
  transition: 0.2s;
  margin-left: 4px;
  margin-top: 4px;
}
.OrderItem_pdfBlock__download__uabGL img {
  max-height: 14px;
}
@media (hover: hover) {
  .OrderItem_pdfBlock__download__uabGL:hover {
    background: #F0F1F5;
  }
}

.OrderItem_canceled__Td-8R {
  margin-top: 6px;
  color: #FA8B81;
  font-size: 12px;
  font-weight: 500;
}

.OrderItem_ratingBtn__tV8uH {
  margin-top: 8px;
  width: 100%;
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  color: var(--accent-text-color);
  border-radius: 12px;
  background: var(--accent-color);
  transition: var(--transition);
  transition-property: opacity;
  font-size: var(--fz-sm);
  line-height: var(--lh-xs);
}
@media (hover: hover) {
  .OrderItem_ratingBtn__tV8uH:hover {
    opacity: 0.7;
  }
}
@media (min-width: 1200px) {
  .OrderItem_ratingBtn__tV8uH {
    background: none;
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
    font-weight: 600;
    color: var(--accent-color);
    width: auto;
    padding: 0;
    margin-top: 4px;
  }
}
.OrderItem_ratingBtn__iconWrap__NoPAB {
  display: none;
  width: 12px;
  height: 12px;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
}
@media (min-width: 1200px) {
  .OrderItem_ratingBtn__iconWrap__NoPAB {
    display: flex;
  }
}

.OrderItem_orderItem__\\+DwUn .OrderItem_coordination-status-label__dM5dH {
  margin-top: 6px;
  margin-left: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/Button/Button.module.scss","webpack://./src/components/OrderItem/OrderItem.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ACCF;ADCE;EACE;IACE,YAAA;ECCJ;AACF;ADEE;EAvBF;IAwBI,eAAA;IACA,YAAA;ECCF;AACF;ADCE;EA5BF;IA6BI,eAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;ECEF;AACF;ADAE;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;ACEJ;ADCE;EAEE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;ACAJ;ADGE;EACE,QAAA;EACA,qDAAA;EACA,aAAA;ACDJ;ADIE;EACE,oBAAA;ACFJ;ADII;EAHF;IAII,aAAA;ECDJ;AACF;ADIE;EACE,oBAAA;ACFJ;ADKM;EACE,qBAAA;ACHR;ADMU;EACE,aAAA;ACJZ;ADWE;EACE,mBAAA;EACA,wBAAA;ACTJ;ADYE;EACE,qEAAA;ACVJ;ADaE;EACE,8BAAA;EACA,wBAAA;ACXJ;ADaI;EACE;IACE,qCAAA;IACA,+BAAA;ECXN;AACF;ADeE;EACE,qDAAA;EACA,0BAAA;ACbJ;ADeI;EACE;IACE,qCAAA;IACA,+BAAA;ECbN;AACF;ADiBE;EACE,WAAA;EACA,eAAA;ACfJ;ADkBE;EACE,YAAA;AChBJ;ADkBI;EAHF;IAII,kBAAA;IACA,mBAAA;ECfJ;AACF;ADkBE;EACE,YAAA;AChBJ;ADkBI;EAHF;IAII,YAAA;IACA,eAAA;ECfJ;AACF;ADiBI;EARF;IASI,YAAA;IACA,eAAA;IACA,mBAAA;ECdJ;AACF;ADiBE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACfJ;ADiBI;EANF;IAOI,YAAA;IACA,kBAAA;IACA,mBAAA;ECdJ;AACF;;ADkBA;EACE;IACE,wCAAA;ECfF;EDiBA;IACE,0CAAA;ECfF;EDiBA;IACE,wCAAA;ECfF;AACF;AArJA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uDAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;AAuJF;AArJE;EACE;IACE,8CAAA;EAuJJ;AACF;AApJE;EArBF;IAsBI,iBAAA;IACA,gBAAA;EAuJF;AACF;AArJE;EACE,gBAAA;AAuJJ;;AAnJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAsJF;AApJE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAsJJ;AAnJE;EAZF;IAaI,iBAAA;EAsJF;AACF;AApJE;EAhBF;IAiBI,SAAA;EAuJF;AACF;;AApJA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAuJF;AArJE;EAVF;IAWI,WAAA;IACA,YAAA;IACA,kBAAA;EAwJF;AACF;AAtJE;EACE,+BAAA;EACA,oDAAA;AAwJJ;AArJE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAuJJ;;AAnJA;EACE,UAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;AAsJF;AApJE;EAPF;IAQI,cAAA;IACA,mBAAA;IACA,cAAA;IACA,WAAA;IACA,mBAAA;IACA,iBAAA;EAuJF;AACF;;AApJA;EACE,YAAA;AAuJF;AArJE;EAHF;IAII,SAAA;IACA,mBAAA;IACA,iBAAA;EAwJF;AACF;AAtJE;EACE,SAAA;AAwJJ;AAtJI;EAHF;IAII,YAAA;IACA,SAAA;EAyJJ;AACF;;AArJA;EACE,SAAA;AAwJF;;AArJA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AAwJF;;AArJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAwJF;AAtJE;EARF;IASI,mBAAA;EAyJF;AACF;;AAtJA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAyJF;AAvJE;EAVF;IAWI,gBAAA;EA0JF;AACF;AAxJE;EACE,gBAAA;AA0JJ;;AAtJA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAyJF;;AAtJA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;AAyJF;AAvJE;EACE,cAAA;EACA,iBAAA;AAyJJ;;AArJA;EACE,aAAA;EACA,mBAAA;AAwJF;AAvJE;EACE,WAAA;EACA,YAAA;AAyJJ;AAtJE;EACE;IACE,WAAA;IACA,YAAA;EAwJJ;AACF;;AApJA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAuJF;AArJE;EANF;IAOI,eAAA;IACA,iBAAA;IACA,cAAA;EAwJF;AACF;;AArJA;EACE,aAAA;EACA,qBAAA;AAwJF;;AAnJE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;AAsJJ;AApJI;EACE,cAAA;AAsJN;AAnJI;EACE,UAAA;EACA,eAAA;EACA,oBAAA;AAqJN;AAlJI;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAoJN;AAjJI;EACE,YAAA;AAmJN;AA/IM;EACE,cAAA;EACA,QAAA;AAiJR;AA3IE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AA6IJ;AA3II;EACE,UAAA;EACA,WAAA;AA6IN;AAzIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA2IJ;AAzII;EACE,gBAAA;AA2IN;AAxII;EACE;IACE,mBAAA;EA0IN;AACF;;AArIA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAwIF;;AArIA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;AAwIF;AAtIE;EACE;IACE,YAAA;EAwIJ;AACF;AArIE;EArBF;IAsBI,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,0BAAA;IACA,WAAA;IACA,UAAA;IACA,eAAA;EAwIF;AACF;AAtIE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAwIJ;AAtII;EARF;IASI,aAAA;EAyIJ;AACF;;AArIA;EACE,eAAA;EACA,cAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAuIF","sourcesContent":[".btn {\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: 12px;\r\n  background-color: var(--accent-color);\r\n  transition: 0.2s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px 16px;\r\n  color: var(--accent-text-color);\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  position: relative;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    font-size: 20px;\r\n    height: 76px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    font-size: 12px;\r\n    width: auto;\r\n    height: 36px;\r\n    padding: 0 32px;\r\n  }\r\n\r\n  &:disabled {\r\n    cursor: default;\r\n    pointer-events: none;\r\n    background-color: #EEEEEE;\r\n    color: rgba(#151B26, 0.4)\r\n  }\r\n\r\n  &__loader,\r\n  &__icon {\r\n    position: absolute;\r\n    transform: translateY(-50%);\r\n    right: 12px;\r\n    width: 16px;\r\n    height: 16px;\r\n    transform-origin: center;\r\n  }\r\n\r\n  &__loader {\r\n    top: 50%;\r\n    animation: loader 2s infinite linear;\r\n    display: none;\r\n  }\r\n\r\n  &__icon {\r\n    top: calc(50% + 2px);\r\n\r\n    @media (min-width: 1200px) {\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  &--is-loading {\r\n    pointer-events: none;\r\n\r\n    .btn {\r\n      &__loader {\r\n        display: inline-block;\r\n\r\n        & + .btn {\r\n          &__icon {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &--gray {\r\n    background: #EEEEEE;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  &--warning {\r\n    background: linear-gradient(87.49deg, #FA7B45 -0.07%, #F44C4C 95.73%);\r\n  }\r\n\r\n  &--white {\r\n    background-color: var(--white);\r\n    color: var(--text-color);\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--light {\r\n    background-color: rgba(var(--accent-color-rgb), 0.12);\r\n    color: var(--accent-color);\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--sm-width {\r\n    width: 94px;\r\n    min-width: 94px;\r\n  }\r\n\r\n  &--sm {\r\n    height: 32px;\r\n\r\n    @media (min-width: 1200px) {\r\n      padding-left: 16px;\r\n      padding-right: 16px;\r\n    }\r\n  }\r\n\r\n  &--md {\r\n    height: 66px;\r\n\r\n    @media (min-width: 640px) {\r\n      height: 76px;\r\n      font-size: 20px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 44px;\r\n      font-size: 12px;\r\n      line-height: normal;\r\n    }\r\n  }\r\n\r\n  &--xsm {\r\n    height: 44px;\r\n    border-radius: 12px;\r\n    padding-left: 18px;\r\n    padding-right: 18px;\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 24px;\r\n      border-radius: 6px;\r\n      line-height: normal;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes loader {\r\n  0% {\r\n    transform: translateY(-50%) rotate(0deg);\r\n  }\r\n  0% {\r\n    transform: translateY(-50%) rotate(360deg);\r\n  }\r\n  100% {\r\n    transform: translateY(-50%) rotate(0deg);\r\n  }\r\n}\r\n","//@import \"../OrdersLine/OrdersLine.module.scss\";\n@import \"../Assets/Button/Button.module.scss\";\n\n.orderItem {\n  width: 100%;\n  border-radius: 16px;\n  padding: 8px;\n  background: #fff;\n  box-shadow: 0px 5px 9px 0px #0000000D;\n  position: relative;\n  margin-bottom: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: var(--transition);\n  transition-property: box-shadow;\n  display: flex;\n  align-items: center;\n\n  @media (hover: hover) {\n    &:hover {\n      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  @media (min-width: 640px) {\n    padding: 8px 16px;\n    min-height: 92px;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-width: 100%;\n\n  .content-container {\n    display: flex;\n    align-items: center;\n    padding-right: 32px;\n  }\n\n  @media (min-width: 1200px) {\n    flex-wrap: nowrap;\n  }\n\n  @media (max-width: 1200px) {\n    flex: 1 1;\n  }\n}\n\n.imgWrap {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  margin-right: 8px;\n\n  @media (min-width: 640px) {\n    width: 60px;\n    height: 60px;\n    margin-right: 12px;\n  }\n\n  &--empty {\n    color: var(--accent-text-color);\n    background-color: rgba(var(--accent-color-rgb), 0.3);\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n    overflow: hidden;\n  }\n}\n\n.time, .number {\n  right: 8px;\n  position: absolute;\n  color: #54575C;\n  font-size: var(--fz-sm);\n  line-height: var(--lh-sm);\n\n  @media (min-width: 1200px) {\n    color: #7A808B;\n    font-weight: normal;\n    flex-shrink: 0;\n    right: 16px;\n    padding-bottom: 2px;\n    margin-left: auto;\n  }\n}\n\n.time {\n  bottom: 15px;\n\n  @media (min-width: 1200px) {\n    top: auto;\n    padding-bottom: 2px;\n    margin-left: auto;\n  }\n\n  &.time-for-history {\n    top: 32px;\n\n    @media (min-width: 1200px) {\n      bottom: 16px;\n      top: auto;\n    }\n  }\n}\n\n.number {\n  top: 15px;\n}\n\n.message {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  color: var(--white);\n  line-height: 100%;\n  background-color: #FF3C3C;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #FAFAFA;\n  font-weight: 600;\n  width: 24px;\n  height: 24px;\n  font-size: 11px;\n  padding: 0;\n  z-index: 1;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  overflow: hidden;\n  align-items: flex-start;\n\n  @media (min-width: 1200px) {\n    padding: 0 20px 0 0;\n  }\n}\n\n.name {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 114%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  padding-right: 12px;\n\n  @media (min-width: 1200px) {\n    padding-right: 0;\n  }\n\n  span {\n    font-weight: 400;\n  }\n}\n\n.completedAndRate {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.completed {\n  background: #EEEEEE;\n  height: 24px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 114%;\n  padding: 5px;\n  color: var(--text-color);\n\n  span {\n    color: #7A808B;\n    margin-right: 4px;\n  }\n}\n\n.rate {\n  display: flex;\n  align-items: center;\n  svg {\n    width: 13px;\n    height: 12px;\n  }\n\n  @media (min-width: 1200px) {\n    svg {\n      width: 16px;\n      height: 17px;\n    }\n  }\n}\n\n.description {\n  margin-top: 1px;\n  line-height: 114%;\n  font-size: 12px;\n  color: #54575C;\n\n  @media (min-width: 1200px) {\n    font-size: 12px;\n    line-height: 14px;\n    color: #7A808B;\n  }\n}\n\n.btnBlock {\n  display: flex;\n  align-content: center;\n}\n\n.pdfBlock {\n\n  &__btn {\n    margin-top: 4px;\n    margin-left: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 14px;\n    color: var(--blue-500);\n    transition: var(--transition);\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &.loading {\n      opacity: 1;\n      cursor: default;\n      pointer-events: none;\n    }\n\n    & svg {\n      width: 10px;\n      margin-left: 2px;\n      height: 11px;\n    }\n\n    &:hover {\n      opacity: .6;\n    }\n\n    :global {\n      .btn__loader {\n        display: block;\n        right: 0;\n      }\n    }\n  }\n\n\n  &__loaderWp {\n    position: relative;\n    width: 9px;\n    height: 9px;\n    margin-left: 4px;\n\n    & img {\n      width: 9px;\n      height: 9px;\n    }\n  }\n\n  &__download {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 14px;\n    color: var(--text-color);\n    padding: 3px 6px;\n    background: #FAFAFA;\n    text-decoration: none;\n    border-radius: 2px;\n    height: 20px;\n    transition: 0.2s;\n    margin-left: 4px;\n    margin-top: 4px;\n\n    img {\n      max-height: 14px;\n    }\n\n    @media (hover: hover) {\n      &:hover {\n        background: #F0F1F5;\n      }\n    }\n  }\n}\n\n.canceled {\n  margin-top: 6px;\n  color: #FA8B81;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.ratingBtn {\n  margin-top: 8px;\n  width: 100%;\n  display: flex;\n  padding: 16px;\n  justify-content: center;\n  align-items: center;\n  color: var(--accent-text-color);\n  border-radius: 12px;\n  background: var(--accent-color);\n  transition: var(--transition);\n  transition-property: opacity;\n  font-size: var(--fz-sm);\n  line-height: var(--lh-xs);\n\n  @media (hover: hover) {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    background: none;\n    font-size: var(--fz-sm);\n    line-height: var(--lh-sm);\n    font-weight: 600;\n    color: var(--accent-color);\n    width: auto;\n    padding: 0;\n    margin-top: 4px;\n  }\n\n  &__iconWrap {\n    display: none;\n    width: 12px;\n    height: 12px;\n    justify-content: center;\n    align-items: center;\n    margin-left: 2px;\n\n    @media (min-width: 1200px) {\n      display: flex;\n    }\n  }\n}\n\n.orderItem .coordination-status-label {\n  margin-top: 6px;\n  margin-left: 0;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `OrderItem_btn__UhZ8f`,
	"btn__loader": `OrderItem_btn__loader__L-pHe`,
	"btn__icon": `OrderItem_btn__icon__-hTBE`,
	"loader": `OrderItem_loader__TVGGp`,
	"btn--is-loading": `OrderItem_btn--is-loading__vD96g`,
	"btn--gray": `OrderItem_btn--gray__m4OIw`,
	"btn--warning": `OrderItem_btn--warning__bJYHq`,
	"btn--white": `OrderItem_btn--white__iD2py`,
	"btn--light": `OrderItem_btn--light__jKSRs`,
	"btn--sm-width": `OrderItem_btn--sm-width__fMhNT`,
	"btn--sm": `OrderItem_btn--sm__aqIBY`,
	"btn--md": `OrderItem_btn--md__ImA-f`,
	"btn--xsm": `OrderItem_btn--xsm__Z31s-`,
	"orderItem": `OrderItem_orderItem__+DwUn`,
	"inner": `OrderItem_inner__grgou`,
	"content-container": `OrderItem_content-container__ahDho`,
	"imgWrap": `OrderItem_imgWrap__YdFWi`,
	"imgWrap--empty": `OrderItem_imgWrap--empty__oPSeE`,
	"time": `OrderItem_time__6Wyt4`,
	"number": `OrderItem_number__6dqSe`,
	"time-for-history": `OrderItem_time-for-history__Wjfeu`,
	"message": `OrderItem_message__2dAsi`,
	"info": `OrderItem_info__2jMtj`,
	"name": `OrderItem_name__1v7bp`,
	"completedAndRate": `OrderItem_completedAndRate__8sJd8`,
	"completed": `OrderItem_completed__Vgtl1`,
	"rate": `OrderItem_rate__niycr`,
	"description": `OrderItem_description__019YS`,
	"btnBlock": `OrderItem_btnBlock__4-uWO`,
	"pdfBlock__btn": `OrderItem_pdfBlock__btn__rRzEF`,
	"loading": `OrderItem_loading__6aZvz`,
	"pdfBlock__loaderWp": `OrderItem_pdfBlock__loaderWp__PwbqW`,
	"pdfBlock__download": `OrderItem_pdfBlock__download__uabGL`,
	"canceled": `OrderItem_canceled__Td-8R`,
	"ratingBtn": `OrderItem_ratingBtn__tV8uH`,
	"ratingBtn__iconWrap": `OrderItem_ratingBtn__iconWrap__NoPAB`,
	"coordination-status-label": `OrderItem_coordination-status-label__dM5dH`
};
export default ___CSS_LOADER_EXPORT___;
